<template>
  <div v-transfer-dom :data-transfer="transfer">
    <transition name="fade">
      <div :class="prefixCls+'-mask'" v-show="visible" @click.self="handleMaskClick"></div>
    </transition>
    <transition name="actionSheet">
      <div :class="prefixCls" v-show="visible">
        <slot></slot>
        <ul :class="prefixCls+'-menu'">
          <li :class="prefixCls+'-menu-item'" v-for="(text,key,$index) in menu" v-html="text"
              @click="onMenuClick(text,key,$index)"></li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
  const prefixCls = 'nio-action-sheet';
  import TransferDom from '../../directives/transfer-dom'

  export default {
    name: "",
    directives: {TransferDom},
    props: {
      value: {
        type: Boolean,
        default: false
      },
      transfer: {
        type: Boolean,
        default: true
      },
      menu: {
        type: Object,
        default: {
          menu1: 'menu1',
          menu2: 'menu2',
          menu3: 'menu3'
        }
      },
      closeOnClickingMenu: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        prefixCls: prefixCls,
        visible: false
      }
    },
    methods: {
      handleMaskClick() {
        this.visible = false;
        this.$emit('input', false)
      },
      onMenuClick(text, key) {
        this.emitEvent('on-click-menu', key, text);
        // if (typeof menu === 'string') {
        //   this.emitEvent('on-click-menu', key, text)
        // } else {
        //   if (menu.type !== 'disabled' && text.type !== 'info') {
        //     if (menu.value || text.value === 0) {
        //       this.emitEvent('on-click-menu', text.value, text)
        //     } else {
        //       this.emitEvent('on-click-menu', '', text)
        //       this.show = false
        //     }
        //   }
        // }
      },
      emitEvent(event, menu, item) {
        console.log(event);
        console.log(menu);
        console.log(item);
        if (event === 'on-click-menu' && !/.noop/.test(menu)) {
          let _item = item
          if (typeof _item === 'object') {
            _item = JSON.parse(JSON.stringify(_item))
          }
          this.$emit(event, menu, _item)
          this.$emit(`${event}-${menu}`)
          if (this.closeOnClickingMenu) {
            this.$emit('input', false)
            this.visible = false
          }
        }
      },
    },
    watch: {
      value: {
        handler(val) {
          this.visible = val;
        },
        immediate: true
      },
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/action-sheet/action-sheet.vue